import { cloneDeep } from 'lodash';
import {
  APPEND_EVENTS_ITEM_ACTION,
  MERGE_REAL_TIME_METRICS,
  PREPEND_EVENTS_ITEM_ACTION,
  RESET_CHARGER_TM_STATE,
  SET_CHARGER_ID,
  SET_CHARGER_METRICS,
  SET_CHARGER_METRICS_BY_AGGREGATION,
  SET_CHARGER_SNAPSHOT,
  SET_EVENTS_ITEMS_ACTION,
  SET_SNAPSHOT_LOADING,
} from '../const';

const defaultState = {
  chargerId: null,
  events: {
    items: [],
  },
  snapshot: {},
  metrics: {},
  snapshotLoading: true,
};

const ChargerTelemetryReducer = (state = defaultState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RESET_CHARGER_TM_STATE:
      return defaultState;
    case SET_EVENTS_ITEMS_ACTION: {
      return { ...state, events: { ...state.events, items: payload } };
    }
    case APPEND_EVENTS_ITEM_ACTION: {
      return { ...state, events: { ...state.events, items: [...state.events.items, payload] } };
    }
    case PREPEND_EVENTS_ITEM_ACTION: {
      return { ...state, events: { ...state.events, items: [payload, ...state.events.items] } };
    }
    case SET_CHARGER_SNAPSHOT: {
      return { ...state, snapshot: payload, snapshotLoading: false };
    }
    case SET_CHARGER_METRICS: {
      return { ...state, metrics: payload, snapshotLoading: false };
    }
    case SET_CHARGER_METRICS_BY_AGGREGATION: {
      return {
        ...state,
        metrics: {
          ...state.metrics,
          [payload.aggregation]: payload.metrics,
        },
      };
    }
    case SET_SNAPSHOT_LOADING: {
      return { ...state, snapshotLoading: payload };
    }
    case SET_CHARGER_ID: {
      return { ...state, chargerId: payload };
    }
    case MERGE_REAL_TIME_METRICS: {
      const metrics = cloneDeep(state.metrics);

      for (const metricKey in payload) {
        if (!metrics[metricKey]) {
          metrics[metricKey] = payload[metricKey];
        } else {
          const data = payload[metricKey];

          for (const ts in data) {
            metrics[metricKey][ts] = data[ts];
          }
        }
      }

      return { ...state, metrics };
    }
    default:
      return state;
  }
};

export default ChargerTelemetryReducer;
